import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './router/Router';
import { useEffect, useState } from 'react';
import Loader from './components/Loader';


const App = () => {
    const [loading, setLoading] = useState(true);

    // useEffect(() => {

    //     setTimeout(() => {
    //         setLoading(false);
    //     }, 400);

    // }, []);


    return (
        
            <BrowserRouter>
                {loading && <Loader />}
                <Router setLoading={setLoading} ></Router>
            </BrowserRouter>
      

    );
}

export default App;
